import { useState } from 'react';
import { Link, Text, Box } from '@/theme/index';

interface ShowMoreProps {
  items: (string | null)[];
  expandedLabel?: string;
  collapsedLabel?: string;
  initialItems?: number;
  hideExtraItems?: boolean;
  inline?: boolean;
  smallAction?: boolean;
  label?: string;
}

export function ShowMore({
  items,
  expandedLabel = 'Less',
  collapsedLabel = 'More',
  initialItems = 2,
  hideExtraItems,
  inline,
  smallAction,
  label,
}: ShowMoreProps) {
  const [expanded, setExpanded] = useState(false);
  const filteredItems = items.slice(0, initialItems);
  const showMore = items.length > filteredItems.length;
  const extraItems =
    showMore && !hideExtraItems && !smallAction
      ? [`${items.length - initialItems}+`]
      : [];

  function onToggle(e: React.MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();
    e.stopPropagation();
    setExpanded(!expanded);
  }

  if (!items.length) {
    return (
      <Text>
        {' '}
        {label
          ? `${label} No ${label.replace(/:\s*/, '')} found`
          : 'No items found'}
      </Text>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: inline ? 'row' : 'column',
        marginRight: inline ? 1 : 0,
      }}
    >
      <Text
        sx={{
          marginRight: inline ? 1 : 0,
        }}
      >
        {label}{' '}
        {expanded
          ? items.join(', ')
          : [...filteredItems, ...extraItems].join(', ')}
      </Text>
      {showMore && (
        <>
          {smallAction ? (
            <Box
              sx={{
                ':hover': { cursor: 'pointer' },
                width: '24px',
                minWidth: '24px',
                height: '24px',
                minHeight: '24px',
                backgroundColor: 'success.light',
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '1px solid',
              }}
            >
              <Text
                sx={{
                  ':hover': { cursor: 'pointer' },
                  lineHeight: '16px',
                  fontSize: '12px',
                  fontWeight: 'bold',
                }}
                onClick={onToggle}
              >
                {`${expanded ? '-' : '+'}${items.length - initialItems}`}
              </Text>
            </Box>
          ) : (
            <Link
              underline="always"
              sx={{ ':hover': { cursor: 'pointer' } }}
              color="success.main"
              onClick={onToggle}
              fontWeight="bold"
            >
              {expanded ? expandedLabel : collapsedLabel}
            </Link>
          )}
        </>
      )}
    </Box>
  );
}
